import LayoutMain from "./layout/main";
import LayoutOffice from "./layout/office";
import NotFound from "./NotFound";

import Main from "./main";
import OfficeMain from "./office";
import News from "./news";
import ЕmployeeСontacts from "./ЕmployeeСontacts";
import ErrorPage from "./ErrorPage";
import AccountingDocuments from "./AccountingDocuments";
import ReportsDownload from "./download/admin";
import ReportsDownloadUser from "./download/user";
import Services from "./Services";
import Schedule from "./schedule/admin";
import ScheduleUser from "./schedule/single";
import ScheduleForm from "./schedule/form";
import UserForm from "./user/form";
import PasswordForm from "./user/passwordForm";
import TheatreForm from "./theatre/form";
import ReportsSummary from "./summary/admin";
import ReportsSummaryUser from "./summary/user";
import NewsView from "./news/view";

export const mainRoutes = [
  { path: "/", component: Main, layout: LayoutMain, exact: true },
  {
    path: "/news",
    component: News,
    layout: LayoutMain,
    exact: true
  },
  {
    path: "/news/:id",
    component: NewsView,
    layout: LayoutMain,
    exact: true
  },
  {
    path: "/error",
    component: ErrorPage,
    layout: LayoutMain,
    exact: true
  },
  {
    path: "/page-not-found",
    component: NotFound,
    layout: LayoutMain
  },
  {
    component: NotFound,
    layout: LayoutMain
  }
];

export const getOfficeRoutes = isAdmin => [
  { path: "/", component: OfficeMain, layout: LayoutOffice, exact: true },
  {
    path: "/news",
    component: News,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/news/:id",
    component: NewsView,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/reports-summary",
    component: isAdmin ? ReportsSummary : ReportsSummaryUser,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/employee-contacts",
    component: ЕmployeeСontacts,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/services",
    component: Services,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/schedule",
    component: isAdmin ? Schedule : ScheduleUser,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/account",
    component: UserForm,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/theatre",
    component: TheatreForm,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/change-password",
    component: PasswordForm,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/schedule/:create",
    component: ScheduleForm,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/schedule/update/:id",
    component: ScheduleForm,
    layout: LayoutOffice,
    exact: true
  },

  {
    path: "/error",
    component: ErrorPage,
    layout: LayoutOffice,
    exact: true
  },

  {
    path: "/reports-download",
    component: isAdmin ? ReportsDownload : ReportsDownloadUser,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/accounting-documents",
    component: AccountingDocuments,
    layout: LayoutOffice,
    exact: true
  },
  {
    path: "/page-not-found",
    component: NotFound,
    layout: LayoutOffice
  },
  {
    component: NotFound,
    layout: LayoutOffice
  }
  /* Последний компонент */
  // {<Route path="/" component={Homes} />}
];



// WEBPACK FOOTER //
// ./src/containers/routes.js